import DOMPurify from 'dompurify';

export const HtmlContent = ({ html, className, as: Tag = 'span' }) => {
  if (!html) return null;

  const sanitized = DOMPurify.sanitize(html);
  return (
    <Tag className={className} dangerouslySetInnerHTML={{ __html: sanitized }} />
  );
};
